import {StateProvider} from "@uirouter/angularjs";
import {UserConfig, UserConfigProvider} from "../types/UserConfig";
import {Branding, isOpenMarketsAppBranding} from "../types/Branding";
import {routerConfig as AllFinClientRouterConfig} from "./routing/AllFinClientDashboardRouterConfig";
import {routerConfig as IGRouterConfig} from "./routing/IGDashboardRouterConfig";
import {routerConfig as IInvestRouterConfig} from "./routing/IInvestDashboardRouterConfig";
import {routerConfig as IvRouterConfig} from "./routing/IvDashboardRouterConfig";
import {routerConfig as OMRouterConfig} from "./routing/OMDashboardRouterConfig";
import {routerConfig as TfRouterConfig} from "./routing/TfDashboardRouterConfig";
import {routerConfig as WaimakClientRouterConfig} from "./routing/WaimakClientRouterConfig";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {
    const userConfig = userConfigProvider.config;
    const branding = userConfig.branding;

    if (branding === Branding.TF) {
        TfRouterConfig($stateProvider, userConfigProvider);
    } else if (branding === Branding.IV) {
        IvRouterConfig($stateProvider, userConfigProvider);
    } else if (branding === Branding.IINVEST) {
        IInvestRouterConfig($stateProvider, userConfigProvider);
    } else if (branding === Branding.WAIMAK) {
        WaimakClientRouterConfig($stateProvider);
    } else if (isOmConfigUser(userConfig)) {
        OMRouterConfig($stateProvider, userConfigProvider);
    } else if (isAllFinClient(userConfig)) {
        AllFinClientRouterConfig($stateProvider);
    } else if (branding === Branding.IG) {
        IGRouterConfig($stateProvider, userConfigProvider);
    }
}

function isOmConfigUser(userConfig: UserConfig): boolean {
    return isAllFinAdviser(userConfig) ||
        ((userConfig.branding !== Branding.ALLFIN) && isOpenMarketsAppBranding(userConfig.branding));
}

/* AllFin Advisers get the normal view */
function isAllFinAdviser(userConfig: UserConfig): boolean {
    return (userConfig.branding === Branding.ALLFIN) && (userConfig.adviser != null);
}

/* AllFin Clients will be directed to a different page */
function isAllFinClient(userConfig: UserConfig): boolean {
    return (userConfig.branding === Branding.ALLFIN) && (userConfig.client != null);
}
